// PricingCard.js

import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    CardActions,
    useTheme,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

function PricingCard({
    plan,
    alignment,
    count,
    renderPricing,
    handleSubPlan,
    isFree = false,
    popular = false,
    featureList,
}) {

    const theme = useTheme();
    return (
        <Card
            variant={popular ? 'outlined' : 'elevation'}
            sx={{
                borderColor: popular ? 'primary.main' : 'grey.300',
                backgroundColor: isFree ? theme.palette.background.default : theme.palette.background.paper,
                boxShadow: popular ? 4 : 1,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="div" gutterBottom>
                    {plan.name}
                </Typography>
                {plan.description && (
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        {plan.description}
                    </Typography>
                )}
                <div>{renderPricing(plan.name)}</div>
                <List dense={true}>
                    {featureList.map((feature, index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText primary={feature} />
                        </ListItem>
                    ))}
                </List>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', mb: 2 }}>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => handleSubPlan(plan.id, plan.name)}
                >
                    {plan.name !== 'Free' ? 'Try free for 14 days' : 'Get Started'}
                </Button>
            </CardActions>
        </Card>
    );
}

export default PricingCard;
